export default {
  kycDocument: '/kyc/business/document',
  documentStatus: '/onboarding/morale/document/status',
};
